module.exports = __webpack_public_path__ + "img/9.045fa285.png";